<script>
    let links = [
        { url: 'https://www.linkedin.com/in/ventycz/', icon: 'linkedin-in', title: 'LinkedIn' },
        { url: 'https://github.com/VentyCZ', icon: 'github', title: 'GitHub' },
        { url: 'https://gitlab.com/ventycz', icon: 'gitlab', title: 'GitLab' },
        { url: 'https://twitter.com/VentyCZ', icon: 'twitter', title: 'Twitter' },
        { url: 'https://twitch.tv/VentyCZ', icon: 'twitch', title: 'Twitch' },
        { url: 'https://steamcommunity.com/id/ventyCZ', icon: 'steam', title: 'Steam' }
    ];
</script>

<style>
    .social-links {
        margin-bottom: 20px;
    }

    @media only screen and (min-width: 1025px) {
        .social-links {
            margin: 20px 0;
        }
    }

    .social-links ul {
        list-style: none;
        padding: 0;
    }

    .social-links ul li {
        display: inline-block;
    }

    .social-links ul li a {
        color: #fff;
        border-radius: 20px;
        font-size: 18px;
        padding: 0;
        height: 30px;
        width: 30px;
        display: block;
        line-height: 30px;
        text-align: center;
        opacity: .9;
    }

    .social-links ul li a:hover {
        opacity: 1;
        background-color: rgba(255, 255, 255, .2);
    }
</style>

<div class="social-links">
    <ul>
        {#each links as link}
            <li>
                <a href={link.url} target="_blank" rel="noreferrer" title={link.title} aria-label={link.title}>
                    <i class="fab fa-{link.icon}"></i>
                </a>
            </li>
        {/each}
    </ul>
</div>
